import React, { useState, useEffect } from 'react';
import { API, C } from '../constants';
import { episodeToMedia } from '../utils';

export default function SeriesModal({ series, apiJson, isMobile, onClose, onPlay }) {
  const [episodes, setEpisodes] = useState([]);
  const [season, setSeason]     = useState(1);

  useEffect(() => {
    apiJson(`${API}/api/series/${series.id}/episodes`)
      .then(d => { if (Array.isArray(d)) { setEpisodes(d); if (d.length) setSeason(d[0].season); } })
      .catch(() => {});
  }, [series.id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const esc = e => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [onClose]);

  const seasons = [...new Set(episodes.map(e => e.season))].sort((a,b) => a-b);
  const eps     = episodes.filter(e => e.season === season).sort((a,b) => a.episode-b.episode);
  const thumb   = series.poster ? `${API}/thumbnail/${encodeURIComponent(series.poster)}` : null;

  return (
    <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.88)', zIndex:2000, display:'flex', alignItems:'flex-start', justifyContent:'center', padding: isMobile?'0':'40px 20px', overflowY:'auto' }}>
      <div onClick={e => e.stopPropagation()} style={{ background:C.bgModal, border:`1px solid ${C.border}`, borderRadius: isMobile?'0':'20px', width:'100%', maxWidth:'760px', minHeight: isMobile?'100vh':'auto' }}>
        <div style={{ display:'flex', gap: isMobile?'14px':'24px', padding: isMobile?'16px':'28px', borderBottom:`1px solid ${C.border}` }}>
          {thumb && <img src={thumb} alt={series.name} style={{ width: isMobile?'80px':'120px', height: isMobile?'120px':'180px', objectFit:'cover', borderRadius:'10px', flexShrink:0 }} />}
          <div style={{ flex:1, minWidth:0 }}>
            <h2 style={{ fontFamily:'Playfair Display, serif', fontSize: isMobile?'20px':'26px', color:C.text, marginBottom:'8px' }}>{series.name}</h2>
            <div style={{ display:'flex', gap:'8px', flexWrap:'wrap', marginBottom:'10px' }}>
              {series.year > 0 && <span style={{ background:C.accentDim, color:C.accentSoft, fontSize:'11px', padding:'2px 8px', borderRadius:'20px', border:`1px solid ${C.accentBorder}` }}>{series.year}</span>}
              {series.genre && <span style={{ color:C.textMuted, fontSize:'12px', padding:'2px 8px' }}>{series.genre}</span>}
              <span style={{ color:C.textDim, fontSize:'12px', padding:'2px 8px' }}>{series.ep_count} episodios</span>
            </div>
            {series.synopsis && <p style={{ color:C.textMuted, fontSize:'13px', lineHeight:'1.6', display:'-webkit-box', WebkitLineClamp:4, WebkitBoxOrient:'vertical', overflow:'hidden' }}>{series.synopsis}</p>}
          </div>
          <button onClick={onClose} style={{ background:'transparent', border:`1px solid ${C.accentBorder}`, color:C.textMuted, width:'32px', height:'32px', borderRadius:'8px', cursor:'pointer', fontSize:'16px', flexShrink:0 }}>✕</button>
        </div>
        {seasons.length > 0 && (
          <div style={{ display:'flex', gap:'8px', padding:`12px ${isMobile?'16px':'28px'}`, borderBottom:`1px solid ${C.border}`, overflowX:'auto' }}>
            {seasons.map(s => (
              <button key={s} onClick={() => setSeason(s)} style={{ padding:'6px 18px', borderRadius:'20px', border:`1px solid ${season===s?'transparent':C.accentBorder}`, background:season===s?`linear-gradient(135deg,${C.accent},${C.accentSoft})`:C.accentDim, color:season===s?'#fff':C.textMuted, cursor:'pointer', fontSize:'13px', fontWeight:'500', whiteSpace:'nowrap' }}>T{s}</button>
            ))}
          </div>
        )}
        <div style={{ padding: isMobile?'8px':'16px 20px' }}>
          {eps.length === 0 ? (
            <p style={{ color:C.textDim, textAlign:'center', padding:'40px 0', fontSize:'14px' }}>Sin episodios asignados en esta temporada</p>
          ) : eps.map(ep => {
            const pct         = ep.duration > 0 ? Math.min((ep.progress / ep.duration) * 100, 99) : 0;
            const hasProgress = ep.progress > 10 && ep.duration > 0 && pct < 95;
            const epTitle     = ep.title || `Episodio ${ep.episode}`;
            return (
              <div key={ep.id}
                onClick={() => {
                  onPlay(episodeToMedia(ep));
                  window.scrollTo({top:0, behavior:'smooth'});
                  onClose();
                }}
                style={{ display:'flex', alignItems:'center', gap:'14px', padding:`${isMobile?'10px':'14px'} 8px`, borderRadius:'10px', cursor:'pointer', borderBottom:`1px solid ${C.border}`, transition:'background 0.15s' }}
                onMouseEnter={e => e.currentTarget.style.background=C.bgCard}
                onMouseLeave={e => e.currentTarget.style.background='transparent'}>
                <div style={{ width:'38px', height:'38px', borderRadius:'50%', background:C.accentDim, border:`1px solid ${C.accentBorder}`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  <span style={{ color:C.accentSoft, fontSize:'14px', fontWeight:'700' }}>{ep.episode}</span>
                </div>
                <div style={{ flex:1, minWidth:0 }}>
                  <p style={{ color:C.text, fontSize:'14px', fontWeight:'500', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{epTitle}</p>
                  {ep.synopsis && <p style={{ color:C.textMuted, fontSize:'11px', marginTop:'2px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{ep.synopsis}</p>}
                  {hasProgress && (
                    <div style={{ height:'2px', background:'rgba(255,255,255,0.1)', borderRadius:'1px', marginTop:'6px' }}>
                      <div style={{ height:'100%', width:`${pct}%`, background:`linear-gradient(90deg,${C.accent},${C.accentSoft})`, borderRadius:'1px' }} />
                    </div>
                  )}
                </div>
                <span style={{ color:C.accentSoft, fontSize:'18px', flexShrink:0 }}>▶</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
